<template>
  <div class="admin-dom-wrapper">
    <admin-nav active="utilisateurs" />
    <b-container fluid>
      <b-card>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">
            Gestion des administrateurs
          </h4>
          <b-button
            variant="primary"
            @click="openCreate"
          >
            + Nouvel admin
          </b-button>
        </div>
        <b-table
          :items="admins"
          :fields="fields"
          responsive
          striped
        >
          <template #cell(prenom)="row">
            {{ row.item.prenom }} {{ row.item.nom }}
          </template>
          <template #cell(superadmin)="row">
            <b-badge :variant="row.item.superadmin ? 'warning' : 'secondary'">
              {{ row.item.superadmin ? 'Superadmin' : 'Admin' }}
            </b-badge>
          </template>
          <template #cell(actif)="row">
            <b-badge :variant="row.item.actif ? 'success' : 'dark'">
              {{ row.item.actif ? 'Actif' : 'Désactivé' }}
            </b-badge>
          </template>
          <template #cell(dateDerniereConnexion)="row">
            {{ formatDate(row.item.dateDerniereConnexion) }}
          </template>
          <template #cell(actions)="row">
            <b-button-group size="sm">
              <b-button
                variant="outline-primary"
                @click="openEdit(row.item)"
              >
                Modifier
              </b-button>
              <b-button
                variant="outline-warning"
                @click="openReset(row.item)"
              >
                Reset mdp
              </b-button>
              <b-button
                variant="outline-danger"
                :disabled="row.item.ui === myUI"
                @click="supprimer(row.item)"
              >
                Supprimer
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-card>
    </b-container>

    <!-- Modale création / édition -->
    <b-modal
      v-model="showForm"
      :title="editing ? 'Modifier l\'admin' : 'Créer un admin'"
      :ok-title="editing ? 'Enregistrer' : 'Créer'"
      cancel-title="Annuler"
      @ok="submitForm"
    >
      <b-form-group label="Email">
        <b-form-input
          v-model="form.email"
          type="email"
          :disabled="editing"
          required
        />
      </b-form-group>
      <b-form-group label="Prénom">
        <b-form-input v-model="form.prenom" />
      </b-form-group>
      <b-form-group label="Nom">
        <b-form-input v-model="form.nom" />
      </b-form-group>
      <b-form-group
        v-if="!editing"
        label="Mot de passe (8+ caractères)"
      >
        <b-form-input
          v-model="form.password"
          type="password"
          minlength="8"
          required
        />
      </b-form-group>
      <b-form-checkbox v-model="form.superadmin">
        Superadmin (peut gérer les autres comptes)
      </b-form-checkbox>
      <b-form-checkbox
        v-if="editing"
        v-model="form.actif"
        class="mt-1"
      >
        Compte actif
      </b-form-checkbox>
    </b-modal>

    <!-- Modale reset password -->
    <b-modal
      v-model="showReset"
      title="Nouveau mot de passe"
      ok-title="Définir"
      cancel-title="Annuler"
      @ok="submitReset"
    >
      <p>
        Pour <strong>{{ resetTarget ? resetTarget.email : '' }}</strong>
      </p>
      <b-form-group label="Nouveau mot de passe (8+ caractères)">
        <b-form-input
          v-model="resetPassword"
          type="password"
          minlength="8"
          required
        />
      </b-form-group>
    </b-modal>

    <!-- Modale confirmation de suppression -->
    <b-modal
      v-model="showDelete"
      title="Supprimer l'administrateur"
      ok-title="Supprimer"
      ok-variant="danger"
      cancel-title="Annuler"
      @ok="confirmDelete"
    >
      <p v-if="deleteTarget">
        Confirmer la suppression du compte
        <strong>{{ deleteTarget.email }}</strong> ?
      </p>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BContainer, BTable, BButton, BButtonGroup, BBadge, BModal,
  BFormGroup, BFormInput, BFormCheckbox,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AdminNav from './AdminNav.vue'

export default {
  components: {
    BCard,
    BContainer,
    BTable,
    BButton,
    BButtonGroup,
    BBadge,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    AdminNav,
  },
  data() {
    return {
      admins: [],
      myUI: null,
      showForm: false,
      editing: null,
      form: { email: '', prenom: '', nom: '', password: '', superadmin: false, actif: true },
      showReset: false,
      resetTarget: null,
      resetPassword: '',
      showDelete: false,
      deleteTarget: null,
      fields: [
        { key: 'email', label: 'Email' },
        { key: 'prenom', label: 'Nom' },
        { key: 'superadmin', label: 'Rôle' },
        { key: 'actif', label: 'État' },
        { key: 'dateDerniereConnexion', label: 'Dernière connexion' },
        { key: 'actions', label: '' },
      ],
    }
  },
  created() {
    const raw = localStorage.getItem('domAdminData')
    if (raw) this.myUI = JSON.parse(raw).ui
    this.load()
  },
  methods: {
    authHeaders() {
      return { headers: { 'x-access-token': localStorage.getItem('domAdminToken') } }
    },
    load() {
      this.$http.get('/admindom/admins', this.authHeaders())
        .then(r => {
          if (r.data.res === 1) this.admins = r.data.admins
        })
        .catch(err => this.handleAuth(err))
    },
    openCreate() {
      this.editing = null
      this.form = { email: '', prenom: '', nom: '', password: '', superadmin: false, actif: true }
      this.showForm = true
    },
    openEdit(a) {
      this.editing = a
      this.form = {
        email: a.email,
        prenom: a.prenom,
        nom: a.nom,
        password: '',
        superadmin: a.superadmin,
        actif: a.actif,
      }
      this.showForm = true
    },
    submitForm(e) {
      e.preventDefault()
      if (this.editing) {
        this.$http.patch(`/admindom/admins/${this.editing.ui}`, {
          nom: this.form.nom,
          prenom: this.form.prenom,
          superadmin: this.form.superadmin,
          actif: this.form.actif,
        }, this.authHeaders())
          .then(r => this.handleWrite(r, 'Admin modifié'))
          .catch(err => this.handleAuth(err))
      } else {
        this.$http.post('/admindom/admins', {
          email: this.form.email,
          password: this.form.password,
          nom: this.form.nom,
          prenom: this.form.prenom,
          superadmin: this.form.superadmin,
        }, this.authHeaders())
          .then(r => this.handleWrite(r, 'Admin créé'))
          .catch(err => this.handleAuth(err))
      }
    },
    openReset(a) {
      this.resetTarget = a
      this.resetPassword = ''
      this.showReset = true
    },
    submitReset(e) {
      e.preventDefault()
      this.$http.post(`/admindom/admins/${this.resetTarget.ui}/resetpassword`, {
        password: this.resetPassword,
      }, this.authHeaders())
        .then(r => this.handleWrite(r, 'Mot de passe modifié'))
        .catch(err => this.handleAuth(err))
    },
    supprimer(a) {
      this.deleteTarget = a
      this.showDelete = true
    },
    confirmDelete(e) {
      e.preventDefault()
      this.$http.delete(`/admindom/admins/${this.deleteTarget.ui}`, this.authHeaders())
        .then(r => this.handleWrite(r, 'Admin supprimé'))
        .catch(err => this.handleAuth(err))
    },
    handleWrite(r, msg) {
      if (r.data.res === 1) {
        this.showForm = false
        this.showReset = false
        this.showDelete = false
        this.load()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: msg, variant: 'success', icon: 'CheckCircleIcon' },
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: r.data.message || 'Erreur', variant: 'danger', icon: 'AlertTriangleIcon' },
        })
      }
    },
    handleAuth(err) {
      if (err && err.response && (err.response.status === 401 || err.response.status === 403)) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: err.response.data.message || 'Accès refusé', variant: 'danger', icon: 'AlertTriangleIcon' },
        })
      }
    },
    formatDate(d) {
      if (!d) return '—'
      const dt = new Date(d)
      return `${dt.toLocaleDateString('fr-FR')} ${dt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
    },
  },
}
</script>

<style lang="scss">
.admin-dom-wrapper {
  min-height: 100vh;
  background-color: #f8f8f8;
  padding-bottom: 2rem;
}
</style>
